<template>
  <div class="online-cv-main" @click.stop="$emit('close')">
    <div class="content" @click.stop>
      
      <!-- 用户基本信息 模块 -->
      <div class="basic-info">

        <!-- 用户基本信息 头部 -->
        <div class="basic-info-header">
          <!-- 头像 -->
          <img class="basic-info-avatar" :src="data.resume.info.profile.avatar_url || 'https://files.wondercv.com/taro_searchResume_miniprogram/headImg_square1.png'" alt="">
          <div class="basic-info-detail">
            <!-- 名字 -->
            <div class="basic-info-name">
              <h6>{{ data.resume.info.profile.username }}</h6>
              <div class="update-online-cv-btn"  v-if="isUpdated || isPerfect" @click="debounce(() => { triggerUpdateOnlineCvFunc() }, 300)">
                <i class="iconfont iconrefresh"></i><span>更新简历</span>
              </div>
            </div>
            <!-- 公司 或 学校 -->
            <div class="basic-info-desc">
              <label>基本信息：</label>
              <span>{{workExperience}}</span>
              <span v-if="workExperience"> | </span>
              <template v-if="data.resume.info.education_experiences[data.recent_edu_index]">
                <template v-if="data.profession_identity === '已工作'">
                  <span v-if="companyName">{{ companyName }}</span>
                  <span v-if="companyName"> | </span>
                </template>
                <template v-else>
                  <span v-if="schoolName">{{schoolName}}</span>
                  <span v-if="schoolName"> | </span>
                </template>
                <span v-if="degreeName">{{degreeName}}</span>
                <span v-if="degreeName"> | </span>
              </template>
            </div>
            <!-- 求职意向 -->
            <div class="basic-info-intention">
              <label>求职意向：</label>

              <!-- 城市 -->
              <template v-if="data.resume.info.basic_info.expected_location && data.resume.info.basic_info.expected_location.length">
                <span>{{ data.resume.info.basic_info.expected_location.join('/') }}</span>
                <span> | </span>
              </template>

              <template v-else-if="data.resume.info.basic_info.predict_cities && data.resume.info.basic_info.predict_cities.length">
                <span>{{ data.resume.info.basic_info.predict_cities.join('/') }}</span>
                <span> | </span>
              </template>

              <!-- 职位 -->
              <template v-if="data.resume.info.profile.exp_job">
                <span>{{ data.resume.info.profile.exp_job }}</span>
                <span> | </span>
              </template>

              <template v-else-if="data.resume.info.basic_info.exp_job">
                <span>{{ data.resume.info.basic_info.exp_job }}</span>
                <span> | </span>
              </template>

              <!-- 薪资 -->

              <template v-if="userIdentify === 'student'">

                <template v-if="data.resume.info.profile.expected_salary">
                  <span>{{ data.resume.info.profile.expected_salary }}</span>
                  <span> | </span>
                </template>

                <template v-else>
                  <span>面议</span>
                  <span> | </span>
                </template>

              </template>

              <template v-else>

                <template v-if="data.resume.info.profile.expected_salary">
                  <span>{{ data.resume.info.profile.expected_salary }}</span>
                  <span> | </span>
                </template>

                <template v-else-if="data.resume.info.basic_info.expected_salary">
                  <span>{{ data.resume.info.basic_info.expected_salary }}</span>
                  <span> | </span>
                </template>

                <template v-else>
                  <span>面议</span>
                  <span> | </span>
                </template>

              </template>

              <div class="intention-icon iconfont iconcuowu" ref="intentionIcon" v-if="intentionIconVisible">
                <span class="placeholder"></span>
                <div class="intention-box" ref="intentionBox">
                  <p>当前求职意向为根据简历预测的结果，可手动设置求职意向，提高求职效率</p>
                  <button @click="debounce(() => { triggerSetIntentionDialogFunc() }, 300)">修改求职意向</button>
                </div>
              </div>
              
            </div>
            <!-- 联系方式 -->
            <div class="basic-info-contact">
              <label class="basic-info-phone">电话：<span>{{ data.resume.info.profile.phone }}</span></label>
              <label class="basic-info-email">邮箱：<span>{{ data.resume.info.profile.email }}</span></label>
              <button class="fast-contact-btn" v-if="!contactDirectlyVisible" @click="debounce(() => { setPersonPrivacyFunc() }, 300)">立即开启</button>
            </div>
            <!-- 极速联系文案 -->
            <div class="basic-info-fast" v-if="!contactDirectlyVisible">联系方式在推荐简历中已隐藏，开启极速联系，允许HR主动与你交换联系方式，提升求职效率</div>
            <div class="basic-info-fast" v-else>联系方式在推荐简历中已隐藏，HR需与你交换联系方式后才可查看</div>
          </div>
        </div>

        <!-- 用户基本信息 内容 -->
        <div class="basic-info-content" v-if="basicInfoVisible">

          <div class="basic-info-content-title">个人信息</div>

          <div class="info-text" v-if="data.resume.info.profile.address">地址：{{data.resume.info.profile.address}}</div>
          <div class="info-text" v-if="data.resume.info.profile.homepage">个人网站：{{data.resume.info.profile.homepage}}</div>

          <div class="info-text hedden-span" v-if="data.resume.info.profile.gender || data.resume.info.profile.height || data.resume.info.profile.weight">
            个人信息：
            <span v-if="data.resume.info.profile.age">{{data.resume.info.profile.age}}</span>
            <span v-if="data.resume.info.profile.age"> | </span>
            <span v-if="data.resume.info.profile.gender">{{data.resume.info.profile.gender}}</span>
            <span v-if="data.resume.info.profile.gender"> | </span>
            <span v-if="data.resume.info.profile.height">{{data.resume.info.profile.height}}</span>
            <span v-if="data.resume.info.profile.height"> | </span>
            <span v-if="data.resume.info.profile.weight">{{data.resume.info.profile.weight}}</span>
            <span v-if="data.resume.info.profile.weight"> | </span>
          </div>

          <div class="info-text" v-if="data.resume.info.profile.ethnic">民族：{{data.resume.info.profile.ethnic}}</div>
          <div class="info-text" v-if="data.resume.info.profile.hometown">籍贯：{{data.resume.info.profile.hometown}}</div>
          <div class="info-text" v-if="data.resume.info.profile.marriage">婚姻状况：{{data.resume.info.profile.marriage}}</div>
          <div class="info-text" v-if="data.resume.info.profile.political_status">政治面貌：{{data.resume.info.profile.political_status}}</div>

        </div>

      </div>

      <div class="info" style="margin-top: 10px;" v-if="false">

        <div class="info-picture">
          <img :src="data.resume.info.profile.avatar_url || personInfo.avatar_url || 'https://wondercv-public-resource.oss-cn-beijing.aliyuncs.com/avatars/avatars4.png'"
              alt="">
        </div>

        <div class="info-name">{{data.resume.info.profile.username}}</div>

        <div class="info-msg hedden-span">
          <span>{{workExperience}}</span>
          <span v-if="workExperience"> | </span>
          <template v-if="data.resume.info.education_experiences[data.recent_edu_index]">
            <template v-if="data.profession_identity === '已工作'">
              <span>{{ companyName }}</span>
              <span v-if="companyName"> | </span>
            </template>
            <template v-else>
              <span>{{schoolName}}</span>
              <span v-if="schoolName"> | </span>
            </template>
            <span>{{degreeName}}</span>
            <span v-if="degreeName"> | </span>
          </template>
        </div>

        <div class="info-msg hedden-span">
          <span>{{data.resume.info.profile.expected_salary}}</span>
          <span v-if="data.resume.info.profile.expected_salary"> | </span>
          <span>{{data.resume.info.profile.exp_job}}</span>
          <span v-if="data.resume.info.profile.exp_job"> | </span>
        </div>

        <div class="info-text"><i class="iconfont iconphone"></i> {{data.resume.info.profile.phone}}</div>
        <div class="info-text"><i class="iconfont iconmail"></i> {{data.resume.info.profile.email}}</div>
        <div class="info-text" v-if="data.resume.info.profile.address">地址：{{data.resume.info.profile.address}}</div>
        <div class="info-text" v-if="data.resume.info.profile.homepage">个人网站：{{data.resume.info.profile.homepage}}</div>
        <div class="info-text hedden-span"
             v-if="data.resume.info.profile.gender || data.resume.info.profile.height || data.resume.info.profile.weight">
          个人信息：
          <span v-if="data.resume.info.profile.age">{{data.resume.info.profile.age}}</span>
          <span v-if="data.resume.info.profile.age"> | </span>
          <span v-if="data.resume.info.profile.gender">{{data.resume.info.profile.gender}}</span>
          <span v-if="data.resume.info.profile.gender"> | </span>
          <span v-if="data.resume.info.profile.height">{{data.resume.info.profile.height}}</span>
          <span v-if="data.resume.info.profile.height"> | </span>
          <span v-if="data.resume.info.profile.weight">{{data.resume.info.profile.weight}}</span>
          <span v-if="data.resume.info.profile.weight"> | </span>
        </div>
        <div class="info-text" v-if="data.resume.info.profile.ethnic">民族：{{data.resume.info.profile.ethnic}}</div>
        <div class="info-text" v-if="data.resume.info.profile.hometown">籍贯：{{data.resume.info.profile.hometown}}</div>
        <div class="info-text" v-if="data.resume.info.profile.marriage">婚姻状况：{{data.resume.info.profile.marriage}}</div>
        <div class="info-text" v-if="data.resume.info.profile.political_status">
          政治面貌：{{data.resume.info.profile.political_status}}
        </div>

      </div>

      <!-- <template v-for="(item, index) in moduleData">
        <div class="item" :key="index" v-if="item.infos.length">
          <div class="item-title">{{item.title}}</div>
          <template v-for="(opt, num) in item.infos">
            <div class="item-option" :key="num" v-if="_notEmpty(item.module, item.infos) && item.module !== 'other'">
              <div class="item-name" v-if="item.type === 'edus'">{{opt.university}}</div>
              <div class="item-name" v-else-if="item.type === 'works'">{{opt.company_name}}</div>
              <div class="item-name" v-else-if="opt.name">{{opt.name}}</div>
              <div class="item-menu">
                <div class="item-info">
                  <span v-if="opt.city">{{ opt.city }}</span>
                  <span v-if="opt.major">{{ opt.major }}</span>
                  <span v-if="opt.degree">{{opt.degree }}</span>
                  <span v-if="opt.dept">{{ opt.dept }}</span>
                  <span v-if="opt.cust_uni_school">{{opt.cust_uni_school}}</span>
                  <span v-if="opt.title">{{ opt.title }}</span>
                </div>
                <div class="item-date">
                  <span v-if="opt.start_at">{{moment(opt.start_at).format('YYYY.MM')}}</span>
                  <span v-if="opt.start_at && (opt.present || opt.end_at)">-</span>
                  <span v-if="opt.end_at || opt.present">{{opt.present || moment(opt.end_at).format('YYYY.MM')}}</span>
                </div>
              </div>
              <div class="item-text" v-html="opt.description"></div>
            </div>
            <li class="change-desc" :key="opt.id"
                v-if="item.module === 'other' && opt.info && opt.info.description">
              <span>{{opt.title}}：</span>
              <span>{{opt.info.description}}</span>
            </li>
          </template>
        </div>
      </template> -->
      <cv-preview-content :info="data.resume.info" />
    </div>
  </div>
</template>
<script>
  import api from '@/api'
  import moment from 'moment'
  import cvPreviewContent from './cvPreviewContent'
  import { workingYears } from '../../../assets/js/util'
  import { mapState } from 'vuex'
  import { get_tUser } from '@/assets/js/util'
  import { componentsMixin } from '@/assets/js/mixins/components'

	export default {
		name: 'cv',
		props: {
      // 当前在线简历对应草稿简历是否有更新
      isUpdated: {
        type: Boolean,
        default: false
      },
      // 是否完善信息
      isPerfect: {
        type: Boolean,
        default: false
      },
      // 在线简历数据
      data: {
        type: Object,
        default: {}
      },
      // 用户身份
      userIdentify: {
        type: String,
        default: null
      }
    },
    mixins: [ componentsMixin ],
		data () {
			return {
				moment,
				moduleData: [],
        _c_t: null,
        contactDirectlyVisible: true // 用户直接联系开关 visible 
			}
    },
    components: {
      cvPreviewContent
    },
    created () {
      this._c_t = get_tUser().c_t || ''
      // 获取用户隐私设置信息
      this.getPersonPrivacy()
    },
    mounted () {
      // 初始化 求职意向 tips 位置
      this.initIntentionBoxPosition()
    },
    computed: {
      ...mapState('me', [ 'personInfo' ]),
      // 公司名称
			companyName () {
        let info = this.data.resume.info
				if (info.work_experiences.length) {
					return info.work_experiences[0].company_name
				} else if (info.internship_experiences.length) {
          return info.internship_experiences[0].company_name
        }
			},
      // 学校名称
			schoolName () {
        let resumeInfo = this.data.resume.info
				let info = resumeInfo.education_experiences[this.data.recent_edu_index]
				if (info.cust_uni_name || (info.school && info.school.cn)) {
					return info.cust_uni_name || info.school && info.school.cn
				}
			},
			// 学历名称
			degreeName () {
        let resumeInfo = this.data.resume.info
				let info = resumeInfo.education_experiences[this.data.recent_edu_index]
				if (info.cust_degree || (info.degree_name && info.degree_name.cn)) {
					return info.cust_degree || info.degree_name && info.degree_name.cn
				}
			},
			// 工作经验
			workExperience () {
				return workingYears(this.data.profession_identity, this.data.years_of_work_experience)
			},
      // 控制求职意向 icon 的显示和隐藏
      intentionIconVisible () {
        if (this.userIdentify === 'student') {
          return !this.data.resume.info.basic_info.expected_location || !this.data.resume.info.basic_info.expected_location.length || !this.data.resume.info.basic_info.exp_job
        } else if (this.userIdentify === 'already_work') {
          return !this.data.resume.info.basic_info.expected_location || !this.data.resume.info.basic_info.expected_location.length || !this.data.resume.info.basic_info.exp_job || !this.data.resume.info.basic_info.expected_salary
        } else {
          return false
        }
      },
      basicInfoVisible () {
        return this.data.resume.info.profile.address ||
               this.data.resume.info.profile.homepage ||
               this.data.resume.info.profile.ethnic ||
               this.data.resume.info.profile.hometown ||
               this.data.resume.info.profile.marriage ||
               this.data.resume.info.profile.political_status ||
               this.data.resume.info.profile.gender ||
               this.data.resume.info.profile.height ||
               this.data.resume.info.profile.weight
      }
    },
		watch: {
			data: {
				deep: true,
				immediate: true,
				handler: async function (data) {
					if (!data) {
						return false
					}
					this.getList()
				}
			}
		},
    methods: {
      // 获取隐私设置
      async getPersonPrivacy() {
        try {
          let res = await api.account.getPersonPrivacy(this._c_t)
          if (res.code === 1000) {
            this.contactDirectlyVisible = res.data.contact_directly
          }
        } catch (error) {
          console.error(error)
        }
      },
      // 设置隐私设置
      async setPersonPrivacyFunc() {
        try {
          let res = await api.account.setPersonPrivacy(this._c_t, {contact_directly: true})
          if (res.code === 1000) {
            this.$message.success('开启成功')
            this.contactDirectlyVisible = true
          }
        } catch (error) {
          console.error(error)
        }
      },
      // 初始化 求职意向 tips 位置
      initIntentionBoxPosition () {
        // 拿到 icon 和 box 的原生 dom
        const intentionIconDom = this.$refs['intentionIcon']
        if (!intentionIconDom) return false
        const intentionBoxDom = this.$refs['intentionBox']
        // 获取 icon 距离父元素 left 距离
        let iconX = intentionIconDom.offsetLeft
        // 希望 box 距离父元素的 left 距离
        let boxX = 108
        // 计算差值 这个差值就是 box 相对 icon 的 left 距离值
        let boxLeft = Math.abs(iconX - boxX)
        // 赋值
        intentionBoxDom.style.left = - boxLeft + 'px'
      },
      // 触发 修改求职意向弹窗显示
      triggerSetIntentionDialogFunc () {
        this.$emit('triggerSetIntentionDialogFunc')
      },
      // 触发 更新在线简历函数
      triggerUpdateOnlineCvFunc () {
        this.$emit('triggerUpdateOnlineCvFunc')
      },
			getList () {
				let data = JSON.parse(JSON.stringify(this.data))
				let { basic_info: { sections_position }, custom_sections, basic_info } = data.resume.info
				let { info } = data.resume
				let otherSort = [
					{
						titleField: 'skills',
						infoField: 'skills'
					},
					{
						titleField: 'languages',
						infoField: 'languages'
					},
					{
						titleField: 'certificates',
						infoField: 'certificates'
					},
					{
						titleField: 'else',
						infoField: 'others'
					},
					{
						titleField: 'interests',
						infoField: 'interests'
					},
				]
				let moduleData = []
				sections_position.forEach(item => {
					if (item.id) {
						const index = custom_sections.findIndex(value => item.id === value.id)
						if (index > -1) {
							moduleData.push({
								title: custom_sections[index].section_title,
								infos: custom_sections[index].custom_section_infos,
                type:item.type
							})
						}
					} else if (item.type === 'extras') {
						let otherInfos = []
						otherSort.forEach(v => {
						  // 判断是否存在技能、证书及其他内容，没有内容该模块不进行显示
						  if (info[v.infoField][0]) {
                otherInfos.push({
                  title: basic_info[`${ v.titleField }_title`],
                  info: info[v.infoField][0],
                  type:item.type
                })
              }
						})
						moduleData.push({
							module: 'other',
							title: basic_info.other_title,
							infos: otherInfos,
              type:item.type
						})
					} else {
						moduleData.push({
							title: info.basic_info[`${ item.type.slice(0, -1) }_title`],
							infos: item.type === 'edus' ? info.education_experiences : item.type === 'works' ? info.work_experiences : info.orgs,
              type:item.type
						})
					}
				})
				moduleData.forEach(item => {
					if (item.module !== 'other') {
						item.infos.forEach(val => {
							val.city = val.cust_city_name || (val.city_name instanceof Object ? val.city_name.cn : val.city_name)
							val.degree = val.cust_degree || val.degree_name && val.degree_name.cn
							val.major = val.cust_major_name || val.major_name && val.major_name.cn
							val.university = val.cust_uni_name || val.school && val.school.cn
						})
					}
				})
        this.moduleData = moduleData
			},
			// 预览时某个模块下什么也没有不显示这个模块
			_notEmpty (section, infos) {
				let fields = [
					'company_name',
					'university',
					'major',
					'degree',
					'cust_uni_school',
					'city',
					'dept',
					'title',
					'name',
					'start_at',
					'end_at',
					'present',
					'description'
				]
				if (section === 'other') {
					for (let i = 0; i < infos.length; i++) {
						if (infos[i].info && infos[i].info.description) return true
					}
				} else if (infos && !infos.length) {
					return false
				} else if (infos instanceof Array) {
					for (let i = 0; i < infos.length; i++) {
						for (let j = 0; j < fields.length; j++) {
							if (infos[i][fields[j]]) return true
						}
					}
				}
			},
		},
	}
</script>
<style lang="scss">
  .online-cv-main {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, .5);
    overflow: auto;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    * {
      box-sizing: border-box;
    }
    .hedden-span {
      span {
        &:last-child {
          display: none;
        }
      }
    }
    .content {
      position: relative;
      // width: 696px;
      width: 910px;
      padding: 0 32px 78px;
      background: #fff;
      line-height: 23px;
      margin: 100px auto;
      border-radius: 4px;
      .info {
        position: relative;
        margin: 36px 0;
        .info-picture {
          width: 68px;
          height: 82px;
          position: absolute;
          top: 0;
          right: 0;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
          }
        }
        .info-name {
          font-size: 24px;
          color: #404040;
          font-weight: 700;
          margin-bottom: 3px;
          line-height: 32px;
        }
        .info-msg {
          font-size: 14px;
          color: #606060;
          line-height: 26px;
        }
        .info-text {
          /*height: 26px;*/
          line-height: 26px;
          font-size: 16px;
          color: #404040;
        }
      }
      .item {
        padding: 28px 0;
        border-top: 1px solid #ececec;

        &:first-of-type {
          border-top: none;
        }

        .item-title {
          font-size: 18px;
          line-height: 20px;
          font-weight: 700;
          color: #404040;
          margin-bottom: 24px;
        }
        .change-desc {
          color: #404040;
        }
        .item-option {
          margin-bottom: 18px;
          &:last-child {
            margin-bottom: 0;
          }
        }
        .item-name {
          font-size: 14px;
          font-weight: 600;
          color: #404040;
          height: 26px;
          line-height: 26px;
        }
        .item-menu {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          .item-info {
            color: #606060;
            font-size: 13px;
            span {
              &::before {
                content: '丨';
                //margin-left: -4px;
              }
              &:first-child::before {
                content: '';
                margin-left: 0;
              }
            }
          }
          .item-date {
            font-size: 13px;
            color: #606060;
          }
        }
        .item-text {
          line-height: 22px;
          font-size: 14px;
          font-weight: 400;
          color: #606060;
          ul {
            padding-left: 20px;
          }
          ol {
            padding-left: 26px;
          }
        }
      }

      // 用户基本信息 模块
      .basic-info {
        width: 910px;
        position: relative;
        top: 0;
        left: -32px;

        // 用户基本信息 头部
        .basic-info-header {
          display: flex;
          padding: 50px 32px 24px;
          background: #F5F6FA;
          border-radius: 4px 4px 0px 0px;

          // 头像
          .basic-info-avatar {
            width: 99px;
            height: 119px;
            border-radius: 4px;
            object-fit: cover;
            object-position: center;
            margin-right: 24px;
          }

          // 基本信息
          .basic-info-detail {
            flex: 1;

            label {
              font-size: 14px;
              font-weight: 500;
              color: #404040;
              line-height: 14px;
            }

            // 名字
            .basic-info-name {
              display: flex;
              justify-content: space-between;
              margin-bottom: 16px;

              >h6 {
                width: 630px;
                font-size: 24px;
                font-weight: 600;
                color: #404040;
                line-height: 24px;
              }

              .update-online-cv-btn {
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #FF6644;
                cursor: pointer;
                line-height: 1;

                >i {
                  margin-right: 4px;
                }

                &:hover {
                  color: #ff8569;
                }
              }

            }

            // 公司 或 学校
            .basic-info-desc {
              line-height: 14px;
              margin-bottom: 16px;

              span {
                color: #606060;
                font-size: 14px;
                &:last-of-type {
                  display: none;
                }
              }
            }
            
            // 求职意向
            .basic-info-intention {
              position: relative;
              line-height: 14px;
              margin-bottom: 9px;

              span {
                color: #606060;
                font-size: 14px;

                &:last-of-type {
                  display: none;
                }
              }

              .intention-icon  {
                position: relative;
                display: inline-block;
                width: 14px;
                height: 14px;
                font-size: 14px;
                color: #ff6644;
                margin-left: 8px;
                cursor: pointer;

                &:hover {

                  &::after {
                    display: block;
                  }

                  .intention-box {
                    display: flex;
                  }

                }

                &::after {
                  content: "";
                  display: none;
                  position: absolute;
                  top: -13px;
                  left: 50%;
                  transform: translateX(-50%);
                  width: 0;
                  height: 0;
                  border-left: 7px solid transparent;
                  border-right: 7px solid transparent;
                  border-top: 8px solid #505667;
                }

                .placeholder {
                  position: absolute;
                  top: -5px;
                  left: 0;
                  display: block;
                  width: 14px;
                  height: 5px;
                  background: transparent;
                }

                .intention-box {
                  width: 614px;
                  display: none;
                  position: absolute;
                  justify-content: space-between;
                  top: -61px;
                  left: 0px;
                  align-items: center;
                  padding: 9px 16px;
                  background: #505667;
                  border-radius: 4px;
                  cursor: initial;

                  >p {
                    font-size: 14px;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 20px;
                    // margin-right: 16px;
                  }

                  >button {
                    width: 104px;
                    height: 30px;
                    background: #FFFFFF;
                    border-radius: 15px;
                    box-sizing: border-box;
                    font-size: 12px;
                    font-weight: 500;
                    color: #505667;
                    line-height: 12px;
                  }
                }
              }

            }

            // 联系方式
            .basic-info-contact {
              margin-bottom: 9px;

              .basic-info-phone {
                margin-right: 32px;

                >span {
                  font-weight: 400;
                }
              }

              .basic-info-email {
                margin-right: 32px;
                >span {
                  font-weight: 400;
                }
              }

              .fast-contact-btn {
                width: 72px;
                height: 28px;
                font-weight: 600;
                border-radius: 14px;
                color: #ffffff;
                padding: 0;
                background: #ff6644;

                &:hover {
                  opacity: 0.8;
                }
              }

            }

            // 极速联系文案
            .basic-info-fast {
              width: 100%;
              font-size: 14px;
              font-weight: 400;
              color: #606060;
              line-height: 20px;
              padding: 8px 16px;
              background: #F9F9F9;
              border-radius: 4px;
              border: 1px solid rgba(207, 207, 207, 0.5);
            }

          }

        }

        // 用户基本信息 内容
        .basic-info-content {
          padding: 40px 0 28px;
          margin: 0 32px;
          border-bottom: 1px solid #ececec;

          .basic-info-content-title {
            font-size: 18px;
            font-weight: 600;
            color: #404040;
            line-height: 18px;
            margin-bottom: 24px;
          }

          div {
            color: #606060;
          }
        }

      }

    }
  }
</style>
